import { combineReducers } from "redux";
import getAssetListReducer from "./getAssetListReducer";
import getPortfolioListReducer from "./getPortfolioListReducer";
import getAssetReducer from './getAssetReducer';
import getAssetListddlReducer from './getAssetListddlReducer';
import getTaxSettingReducer from './getTaxSettingReducer';
import { getTaxDetailsReducer, TaxEntityContactAccessReducer, TaxEntityContactsReducer, GetContactRoleReducer, GetContactRoleAccessReducer } from './getTaxDetailsReducer';
import getTaxSummaryReducer from './getTaxSummaryReducer';
import getHoldingsReducer from './getHoldingsReducer'
import getReturnsAndStatisticsReducer from './getReturnsAndStatisticsReducer'
import getFinancialStatementReducer,{getFinancialStatementDocumentReducer,getFsSecurityReducer} from './getFinancialStatement';
import getAssetSettingsReducer from './getAssetSettingsReducer';
import getLeftMenuReducer from './getLeftMenuReducer';
import {
  getAssetDetailsReducer, getAssetInvestReducer, getAssetClassReducer, getFundStatusReducer, getPrimaryAnalystReducer, getSecondaryAnalystReducer,
  getStrategyReducer, getSubStrategyReducer, getRegionReducer, getSubRegionReducer, getSectorReducer, getSubSectorReducer, getAssetAUMWidgetReducer, getAssetReturnsReducer, getAssetShareclassTermsReducer, getAssetPrivateExposureSummaryReducer
} from "./getAssetDetailsReducer";
import { getAssetShareclassReducer, getAssetShareclassDetailsReducer, getAssetShareclassFeeDetailsReducer } from './getAssetShareClassReducer';
import {
    getAssetAttributesReducer, getChartofaccountsReducer, getAttributescurrencyReducer, getAttributelegalStructureReducer, getAssetSecurityTypeReducer, getInvestmentTypeReducer, getInvestorLetterFrequencyReducer, getPerformanceEstimateFrequencyReducer, getReportingFrequencyReducer, getExposureReportingFrequencyReducer, getFilingStatusReducer,
    getInvestsInOtherFundsReducer, getAssetRatingsReducer, getAssetOddRatingsReducer
} from './getAssetAttributesReducer';
import { getAssetDocumentReducer, getAssetMultipleDocumentReducer, getDocumentdetailsReducer, getNoteTabDetailsReducer } from './getAssetDocumentsReducer'

import { getActivitiesDetailsReducer, getCategoryReducer, getActivityTypeReducer, getActivityEntityTypeReducer, getActivityEntityReducer, getActivityDetailReducer,getAccountorContactReducer} from './getinvestmentReducer';
import getUserDetailsReducer from './getprofileReducer';
import { getUsersReducer } from "./getUsersReducer";
import getManagerContactsReducer, { getCommonReducer,getDataSourceReducer,getEnumerationReducer, getContactDetailsReducer } from "./getCommonReducer";
import getAnalyticsReporting from "./getAnalyticsReporting";
import GetAllGlobalEntitiesReducer from "./getGlobalSearchReducer";
import { getemailRuleReducer } from "./getEmailRulesReducer";
import { getPublicExposureReducer } from "./getPublicExposureReducer";
import { getPrivateExposureReducer } from "./getPrivateExposureReducer";

import { getAssetAUMOptReducer} from "./getAssetAumReducer";
import { getAdminPermissionsReducer } from "./getAdminPermissionsReducer";
import { getPostReturnsReducer } from "./getPostReturnsReducer";
import { getMarketData } from "./getmarketdataReducer";
import {getAuthorizationTokenReducer} from './getAuthorizationTokenReducer';
import {getContactListsReducer} from './getContactListsReducer';
import {getProformaConstructionReducer} from './getProformaConstructionReducer';
import {getDocumentsReducer} from './getdocumentReducer';
import { getAssetPricingReducer } from './getAssetPricingReducer';
import getTransactionListReducer from "./getTransactionsReducer";
import  getInvestorTrackingListReducer from "./getInvestorTrackingReducer";
import { getInvestorAccountListReducer } from "./getInvestorAccounts";
import { getTasksReducer } from "./getTasksReducer";
import portfolioReducer from "./portfolioReducer";
import { transactionReducer } from "./transactionReducer";
import { getPortfolioAttributionReducer } from "./getPortfolioAttributionReducer";
import { getPipelineReducer } from "./getPipelineReducer"
import { getThirdPartyDataReducer } from "./getThirdPartyDataReducer";
const rootReducer = combineReducers({
  authorizationData:getAuthorizationTokenReducer,
  common:getCommonReducer,
  assetList: getAssetListReducer,
  portfolioList: getPortfolioListReducer,
  portfolio:portfolioReducer,
  asset: getAssetReducer,
  assetDDL: getAssetListddlReducer,
  taxSetting: getTaxSettingReducer,
  taxDetails: getTaxDetailsReducer,
  taxSummary: getTaxSummaryReducer,
  Holdings: getHoldingsReducer,
  financialDetails: getFinancialStatementReducer,
  assetSecurityType: getAssetDetailsReducer,
  assetInvestStatus: getAssetInvestReducer,
  assetClass: getAssetClassReducer,
  fundStatus: getFundStatusReducer,
  primaryAnalyst: getPrimaryAnalystReducer,
  secondaryAnalyst: getSecondaryAnalystReducer,
  strategy: getStrategyReducer,
  subStrategy: getSubStrategyReducer,
  region: getRegionReducer,
  subregion: getSubRegionReducer,
  sector: getSectorReducer,
  subsector: getSubSectorReducer,
  leftMenu: getLeftMenuReducer,
  ReturnsGridData: getReturnsAndStatisticsReducer,
  assetSettings: getAssetSettingsReducer,
  assetAUM: getAssetAUMWidgetReducer,
  assetReturns: getAssetReturnsReducer,
  bmSettings: getAssetSettingsReducer,
  assetShareClassTerms: getAssetShareclassTermsReducer,
  assetPrivateExposureSummary:getAssetPrivateExposureSummaryReducer,
  assetShareClass: getAssetShareclassReducer,
  shareClassData: getAssetShareclassDetailsReducer,
  shareClassFeeData: getAssetShareclassFeeDetailsReducer,
  attributesDetails: getAssetAttributesReducer,
  chartofaccounts: getChartofaccountsReducer,
  attributescurrency: getAttributescurrencyReducer,
  attributelegalstructure: getAttributelegalStructureReducer,
  securityType: getAssetSecurityTypeReducer,
  investmentType: getInvestmentTypeReducer,
  investorFrequency: getInvestorLetterFrequencyReducer,
  performanceEstimateFrequency: getPerformanceEstimateFrequencyReducer,
  reportingFrequency: getReportingFrequencyReducer,
  exposureReportingFrequency: getExposureReportingFrequencyReducer,
  filingStatus: getFilingStatusReducer,
  investInOtherFunds: getInvestsInOtherFundsReducer,
  assetDocuments: getAssetDocumentReducer,
  mutipleDocuments: getAssetMultipleDocumentReducer,
  documentDetails: getDocumentdetailsReducer,
  activitityDetails: getActivitiesDetailsReducer,
  Category: getCategoryReducer,
  ActivityType: getActivityTypeReducer,
  notesTabDetails: getNoteTabDetailsReducer,
  userDetails: getUserDetailsReducer,
  ActivityentityType: getActivityEntityTypeReducer,
  ActivityEntity:getActivityEntityReducer,
  Users: getUsersReducer,
  AnalyticsReporting:getAnalyticsReporting,
  managerContacts: getManagerContactsReducer,
  DataSourcelist:getDataSourceReducer,
  AllEntities:GetAllGlobalEntitiesReducer,
  emailRules:getemailRuleReducer,
  PublicExposure:getPublicExposureReducer,
  PrivateExposure: getPrivateExposureReducer,
  AssetAUMOpt:getAssetAUMOptReducer,
  AdminPermissions:getAdminPermissionsReducer,
  PostReturns: getPostReturnsReducer,
  //Indices:getMarketData,
  Marketdata:getMarketData,
  enumValues:getEnumerationReducer,
  Contacts:getContactListsReducer,
  ContactDetailsEnumValues:getContactDetailsReducer,
  fsDocuments:getFinancialStatementDocumentReducer,
  fsSecurityDropdown:getFsSecurityReducer,
  ProformaConstruction:getProformaConstructionReducer,
  Documents: getDocumentsReducer,
  activityDetail: getActivityDetailReducer,
  AssetpricingList: getAssetPricingReducer,
  transactionList:getTransactionListReducer,
  investortrackingList:getInvestorTrackingListReducer,
  activityEntities: getAccountorContactReducer,
  AttributesRating:getAssetRatingsReducer,
  investorAccounts: getInvestorAccountListReducer,
  AttributesOddRating: getAssetOddRatingsReducer,
  TaxEntityContactAccess: TaxEntityContactAccessReducer,
  TaxEntityContacts: TaxEntityContactsReducer,
  ContactRoleDefaccess: GetContactRoleAccessReducer,
  ContactRole: GetContactRoleReducer, 
  tasks:getTasksReducer,
  transaction:transactionReducer,
  PortfolioAttribution: getPortfolioAttributionReducer,
  Pipelinedata:getPipelineReducer,
  ThirdPartyData:getThirdPartyDataReducer
});

export default rootReducer;
